import { toast } from 'react-toastify';


const _showToast = (message, kind = "") => {
  setTimeout(() => {
    toast.dismiss();
    if (kind.toLowerCase() == "success")
      _success(message);
    else if (kind.toLowerCase() == "error")
      _error(message);
    else if (kind.toLowerCase() == "warning")
      _warning(message);
    else if (kind.toLowerCase() == "info")
      _info(message);
    else {
      toast(message, {
        autoClose: false
      });
    }
  }, 250);
}

const _success = (message) => {
  toast.success(message, {
    autoClose: true
  });
}

const _error = (message) => {
  toast.error(message, {
    autoClose: true
  });
}


const _warning = (message) => {
  toast.warn(message, {
    autoClose: true
  });
}

const _info = (message) => {
  toast.info(message, {
    autoClose: true
  });
}


export { _showToast };